"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkdownListItem = MarkdownListItem;
exports.MarkdownOrderedList = MarkdownOrderedList;
exports.MarkdownParagraph = MarkdownParagraph;
exports.MarkdownSpan = MarkdownSpan;
exports.MarkdownTable = MarkdownTable;
exports.MarkdownUnorderedList = MarkdownUnorderedList;
var _react = _interopRequireDefault(require("react"));
var _sharedChatTableComponents = require("@common/markdown/sharedChatTableComponents");
var _sharedMarkdownComponents = require("@common/markdown/sharedMarkdownComponents");
var _ChatPage = require("./ChatPage.styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function MarkdownUnorderedList(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPage.StyledUl, _objectSpread(_objectSpread({}, props), {}, {
    "data-sentry-element": "StyledUl",
    "data-sentry-component": "MarkdownUnorderedList",
    "data-sentry-source-file": "chat-page-markdown.tsx",
    children: children
  }));
}
function MarkdownOrderedList(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPage.StyledOl, _objectSpread(_objectSpread({}, props), {}, {
    "data-sentry-element": "StyledOl",
    "data-sentry-component": "MarkdownOrderedList",
    "data-sentry-source-file": "chat-page-markdown.tsx",
    children: children
  }));
}
function MarkdownListItem(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPage.StyledLi, _objectSpread(_objectSpread({}, props), {}, {
    "data-sentry-element": "StyledLi",
    "data-sentry-component": "MarkdownListItem",
    "data-sentry-source-file": "chat-page-markdown.tsx",
    children: children
  }));
}
function MarkdownParagraph(_ref4) {
  var children = _ref4.children,
    node = _ref4.node;
  if ((0, _sharedMarkdownComponents.paragraphHasOnlyBlockSwapIn)(node)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    "data-sentry-component": "MarkdownParagraph",
    "data-sentry-source-file": "chat-page-markdown.tsx",
    children: _react.default.Children.map(children, function (child) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: child
      });
    })
  });
}
function MarkdownSpan(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "data-sentry-component": "MarkdownSpan",
    "data-sentry-source-file": "chat-page-markdown.tsx",
    children: _react.default.Children.map(children, function (child) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: child
      });
    })
  });
}
function MarkdownTable(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPage.TableScrollBox, {
    "data-sentry-element": "TableScrollBox",
    "data-sentry-component": "MarkdownTable",
    "data-sentry-source-file": "chat-page-markdown.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_sharedChatTableComponents.ChatTable, {
      "data-sentry-element": "ChatTable",
      "data-sentry-source-file": "chat-page-markdown.tsx",
      children: children
    })
  });
}